<jni-purchase-order-sidebar
  [(display)]="displaySidebar"
  *ngIf="displaySidebar"
  [saleOrderId]="saleOrderId"
  [directDeliveryVendor]="directDeliveryVendor"
  (purchaseOrderFormEvent)="addPurchaseOrderObject($event)"
  [purchaseOrderIdList]="purchaseOrderIdList"></jni-purchase-order-sidebar>

<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="px-3">
        <div
          class="d-flex justify-content-between align-items-center globalborder-btm-header pb-2 mb-2">
          <div class="d-flex justify-content-between align-items-center gap-3">
            <h2 class="mb-0">Line # {{ orderItemLineNumber }}</h2>
            <h2 class="cross-border mb-0">Order# {{ saleOrderId }}</h2>

            <span
              *ngIf="viewPoNumber"
              (click)="openViewPoNumberPdfScreen(viewPoNumber, saleOrderId)"
              >PO# : <a class="link">{{ viewPoNumber }}</a></span
            >
          </div>

          <div class="d-flex justify-content-between align-items-center gap-3">
            <!-- <span>
              Order# <b>{{ saleOrderId }}</b>
            </span>

            <span (click)="openViewPoNumberPdfScreen(viewPoNumber, saleOrderId)"
              >PO# : <a class="link">{{ viewPoNumber }}</a></span
            > -->

            <div
              class="d-flex align-items-center gap-3 cross-border"
              *ngIf="isModal">
              <i class="pi pi-times" (click)="closeSalesOrderLineModal()"></i>
            </div>
          </div>
        </div>

        <div class="row adduser-container-hgt">
          <div class="orders py-0">
            <form [formGroup]="saleOrderItemLine">
              <div class="orders-srcvendor mb-4">
                <div class="d-flex gap-3 collapseable">
                  <div
                    class="col-line-grid"
                    *ngIf="orderType !== 'inventory-sales'">
                    <div class="gray-bg-rounded">
                      <jni-order-line-vendor
                        #vendor
                        [parent]="saleOrderItemLine"
                        (vendorAccountEvent)="getVendorAccountField($event)"
                        (vendorObjectEvent)="getVendorObject($event)"
                        [formErrors]="formErrors"
                        (validationErrorEvent)="logValidationErrors()"
                        (poAssignmentEvent)="openSideBarForPoAssignment($event)"
                        [poAssignment]="poAssignment"
                        [saleOrderLine]="saleOrderLine"
                        [vendorAccountNumber]="vendorId"
                        [isFromCdi]="isFromCdi"
                        [createdBy]="createdBy"
                        [createdDate]="createdDate"
                        [modifiedBy]="modifiedBy"
                        [modifiedDate]="modifiedDate"
                        [isEdit]="isEdit"
                        (currencyFromVendorEvent)="
                          currencyFromVendorEvent($event)
                        "
                        [orderType]="orderType"
                        [addNewLineCase]="addNewLineCase"
                        (isVendorSelectedEvent)="isVendorSelectedEvent($event)"
                        [collapseStatus]="
                          collapseStatus
                        "></jni-order-line-vendor>
                    </div>
                  </div>
                  <div class="col-line-grid">
                    <div class="gray-bg-rounded">
                      <jni-order-line-ship-to
                        #shipTo
                        [parent]="saleOrderItemLine"
                        [deliveryAddress]="deliveryAddress"
                        [countryRegionList]="countryRegionList"
                        [addressObject]="addressObject"
                        [headerObject]="headerObject"
                        [customerList]="customerLists"
                        [showAddress]="showAddress"
                        [formErrors]="formErrors"
                        [clientShipToAddressDisabled]="
                          clientShipToAddressDisabled
                        "
                        [vendorNameShipToAddressDisabled]="
                          vendorNameShipToAddressDisabled
                        "
                        (validationErrorEvent)="logValidationErrors()"
                        [isEditFromCdi]="isFromCdi"
                        (isMelissaValidationIgnore)="
                          isMelissaValidationIgnoreEvent($event)
                        "
                        (isMelissaAddressValidated)="
                          isMelissaAddressValidatedEvent($event)
                        "
                        [isShipToAddresssFromOrderLines]="true"
                        [lineStatusD365]="lineStatusD365"
                        [collapseStatus]="
                          collapseStatus
                        "></jni-order-line-ship-to>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="d-flex flex-column gap-3">
                      <!-- Details Section -->
                      <div class="gray-bg-rounded">
                        <jni-order-line-item-details
                          #details
                          [parent]="saleOrderItemLine"
                          [shippingProductsList]="shippingProductsList"
                          [customerId]="customerId"
                          [headerShipDate]="shipDate"
                          [headerInhandDate]="inHandDate"
                          [formErrors]="formErrors"
                          (validationErrorEvent)="logValidationErrors()"
                          [orderType]="orderType"></jni-order-line-item-details>
                      </div>

                      <!-- Vendor Specials Section -->
                      <div
                        class="gray-bg-rounded"
                        *ngIf="orderType !== 'inventory-sales'"
                        style="max-height: 400px; overflow: auto">
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                          style="
                            position: sticky;
                            top: 0;
                            background: inherit;
                            z-index: 1;
                            padding-top: 1rem;
                          ">
                          <h3 class="mb-0">Vendor Specials</h3>
                        </div>
                        <div
                          style="
                            overflow-x: auto;
                            overflow-y: auto;
                            max-height: 350px;
                          ">
                          <p-table
                            [value]="vendorSpecials"
                            [loading]="loadingSpecials"
                            [scrollable]="true"
                            scrollHeight="flex"
                            styleClass="p-datatable-sm"
                            [style]="{ 'min-width': '100%' }">
                            <ng-template pTemplate="header">
                              <tr>
                                <th style="white-space: nowrap">
                                  Eligible Product
                                </th>
                                <th style="white-space: nowrap">Description</th>
                                <th style="white-space: nowrap">Pricing</th>
                                <th style="white-space: nowrap">
                                  Effective Date
                                </th>
                                <th style="white-space: nowrap">
                                  Expiration Date
                                </th>
                                <th style="white-space: nowrap">
                                  Vendor Contact
                                </th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-special>
                              <tr>
                                <td style="white-space: nowrap">
                                  {{ special.eligibleProduct }}
                                </td>
                                <td
                                  style="
                                    max-width: 300px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                  ">
                                  <span
                                    [pTooltip]="descriptionTooltip"
                                    tooltipPosition="top"
                                    [showDelay]="300"
                                    [tooltipOptions]="{
                                      tooltipStyleClass: 'custom-tooltip',
                                    }">
                                    {{
                                      special.description &&
                                      special.description.length > 50
                                        ? (special.description
                                            | slice: 0 : 50) + "..."
                                        : special.description
                                    }}
                                  </span>
                                  <ng-template #descriptionTooltip>
                                    <div style="max-width: 400px; padding: 8px">
                                      <strong>Description:</strong>
                                      <div style="margin-top: 4px">
                                        {{ special.description }}
                                      </div>
                                    </div>
                                  </ng-template>
                                </td>
                                <td style="white-space: nowrap">
                                  {{ special.pricing }}
                                </td>
                                <td style="white-space: nowrap">
                                  {{
                                    special.effectiveDate | date: "MM/dd/yyyy"
                                  }}
                                </td>
                                <td style="white-space: nowrap">
                                  {{
                                    special.expirationDate | date: "MM/dd/yyyy"
                                  }}
                                </td>
                                <td style="white-space: nowrap">
                                  {{ special.vendorContact }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="6" class="text-center">
                                  No vendor specials found
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="d-flex justify-content-between">
            <div class="collapse-section border-0 mb-minus-2 position-absolute">
              <a
                class="btn-collapse"
                (click)="onToggle()"
                [ngClass]="{ active: collapseStatus }"
                >{{ collapseHeading }} <i class="icon-angle-double"></i
              ></a>
            </div>
          </div> -->
                    <div class="d-flex justify-content-end mt-minus mt-3">
                      <div class="border-0 collapse-section d-flex">
                        <a
                          class="btn-collapse"
                          (click)="onToggle()"
                          [ngClass]="{ active: collapseStatus }"
                          >{{ collapseHeading }}
                          <i class="icon-angle-double"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col" *ngIf="showHistory">
                <div class="row">
                  <div
                    class="d-flex justify-content-between align-items-center globalborder-btm-header mb-3 pb-3 pt-2">
                    <h2 class="mb-2 text-right">
                      Copied from
                      <a (click)="redirectToCopiedFrom()" class="link bold mx-2"
                        >{{ setCopiedFromInfo() }}
                      </a>
                      {{
                        saleOrderLineHistory.createdDate | date: "MM-dd-yyyy"
                      }}
                    </h2>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <jni-order-line-detail
                    #lineDetail
                    [parent]="saleOrderItemLine"
                    [showCommissionsFields]="showCommissionsFields"
                    [currencyList]="currencyList"
                    [releasedProductsList]="releasedProductsList"
                    [sellCurrencyStatus]="sellCurrencyStatus"
                    [formErrors]="formErrors"
                    (validationErrorEvent)="logValidationErrors()"
                    [netFieldStatus]="netFieldStatus"
                    [sellRateValueWithIconStatus]="sellRateValueWithIconStatus"
                    [userBlockedFromEdit]="userBlockedFromEdit"
                    [orderLineNumber]="orderLineNumber"
                    [salesOrderLine]="salesOrderLine"
                    [isFromCdi]="isFromCdi"
                    [salesClasssificationList]="salesClassificationList"
                    [isSalesClassificationIdRequired]="
                      isSalesClassificationIdRequired
                    "
                    [orderType]="orderType"
                    [customerAccountNumber]="customerId"
                    [releasedProductsVariantsList]="
                      releasedProductsVariantsList
                    "
                    [customerFinancialDimension]="customerFinancialDimension"
                    [selectedItemNumber]="selectedItemNumber"
                    [addNewLineCase]="addNewLineCase"
                    [warehouseList]="warehouseList"
                    [headerSiteId]="headerSiteId"
                    [headerWarehouseId]="headerWarehouseId"
                    [headerLocationId]="headerLocationId"
                    [headerStore]="headerStore"
                    [headerOwner]="headerOwner"
                    [disableConfigFields]="disableConfigFields"
                    [warehouseList]="warehouseList"></jni-order-line-detail>
                </div>

                <div class="col" formGroupName="lines">
                  <div class="gray-bg-rounded">
                    <div class="row">
                      <div class="col">
                        <div class="form-group has-float-label">
                          <div class="d-flex justify-content-between">
                            <label class="form-label">Description</label>
                            <a
                              (click)="
                                showPositionDialogDescription('bottomright')
                              "
                              class="link bold fontbold text-underline"
                              >Stock Phrase</a
                            >
                          </div>
                          <textarea
                            jniAutoCompleteBlocker
                            pInputText
                            id="descriptionid"
                            #scrollBottom
                            rows="15"
                            formControlName="lineDescriptionD365"
                            (focusout)="
                              applylineDescriptionLengthValidation($event)
                            "
                            tabindex="8"></textarea>
                        </div>
                      </div>
                      <div class="col" *ngIf="orderType !== 'inventory-sales'">
                        <div class="d-flex justify-content-between">
                          <label class="form-label">Factory notes</label>
                          <a
                            (click)="showPositionDialogFactory('bottomright')"
                            class="link bold fontbold text-underline"
                            >Stock Phrase</a
                          >
                        </div>
                        <div class="form-group has-float-label">
                          <textarea
                            jniAutoCompleteBlocker
                            #scrollBottom
                            rows="15"
                            pInputText
                            formControlName="factoryNotes"
                            (focusout)="
                              applyfactoryNotesLengthValidation($event)
                            "
                            tabindex="9"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex pt-3 pb-3 has-sticky justify-content-between has-fixed">
                <div class="d-flex gap-3">
                  <p-button
                    label="Copy Header"
                    *ngIf="
                      (lineStatusD365.toLowerCase() !== 'invoiced' &&
                        userBlockedFromEdit &&
                        !isLineProposalExist) ||
                      isPartiallyInvoicedOrderLines
                    "
                    (click)="next('Copy Header')" />

                  <p-button
                    label="Copy Line"
                    *ngIf="
                      (lineStatusD365.toLowerCase() !== 'invoiced' &&
                        userBlockedFromEdit &&
                        !isLineProposalExist) ||
                      isPartiallyInvoicedOrderLines
                    "
                    (click)="next('Copy Line')" />

                  <p-button
                    label="Add Setup"
                    *ngIf="
                      (orderType !== 'inventory-sales' &&
                        lineStatusD365.toLowerCase() !== 'invoiced' &&
                        userBlockedFromEdit &&
                        !isLineProposalExist) ||
                      isPartiallyInvoicedOrderLines
                    "
                    (click)="next('Add Setup')" />

                  <p-button
                    label="Add Misc"
                    *ngIf="
                      (lineStatusD365.toLowerCase() !== 'invoiced' &&
                        userBlockedFromEdit &&
                        !isLineProposalExist) ||
                      isPartiallyInvoicedOrderLines
                    "
                    (click)="next('Misc')"
                    [hidden]="orderType !== 'inventory-sales'" />
                </div>
                <div class="d-flex gap-3">
                  <p-button label="Cancel" (click)="redirectToSummary()" />

                  <p-button
                    label="Done"
                    (click)="onSubmit()"
                    *ngIf="
                      (lineStatusD365.toLowerCase() !== 'invoiced' &&
                        userBlockedFromEdit &&
                        !isLineProposalExist) ||
                      isPartiallyInvoicedOrderLines
                    "
                    tabindex="10" />

                  <p-button
                    (click)="next('Add Line')"
                    label="Add Line"
                    *ngIf="
                      (lineStatusD365.toLowerCase() !== 'invoiced' &&
                        userBlockedFromEdit &&
                        !isLineProposalExist) ||
                      isPartiallyInvoicedOrderLines
                    "
                    tabindex="11" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
<jni-stock-phrases
  #stockPhraseDescription
  [flag]="'description'"
  [displayPosition]="displayPositionDescription"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogDescription()"
  (notesAndFactEvent)="getDescription($event)"
  [validateLoginObject]="validateLoginObject"></jni-stock-phrases>

<jni-stock-phrases
  #stockPhraseFactory
  [flag]="'factory'"
  [displayPosition]="displayPositionFactory"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogFactory()"
  (notesAndFactEvent)="getFactory($event)"
  [validateLoginObject]="validateLoginObject"></jni-stock-phrases>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="copiedFromSalesOrderId"></jni-order-summary>
  </div>
</jni-modal-stacker>
